import SkeletonSearchListItem from "../SearchListItem/components/SkeletonSearchListItem";
import styles from "./searchList.module.scss";
import useSearchList from "./useSearchList";
import getFilterActiveStatus, {
  getDistanceFromCityCenterStatus,
  getStayDurationAppliedStatus,
  getUniversityAppliedStatus,
} from "@Pages/Search/utils/getFilterActiveStatus";
import React from "react";
import BookEarlySection from "../BookEarlySection";
import FilterSubsection from "./components/FilterSubsection";
import GetHelpBannerV2 from "./components/GetHelpBannerV2";
import TrustPilotReviewsBanner from "./components/TrustPilotBanner";
import getSubsectionIndex from "./helper";
import FilterSubsection2 from "./components/FilterSubsection2";
import config from "@Config/index";
import RecentelyViewedSection from "../RecentelyViewedSection/RecentelyViewedSection";
import { PAGE } from "constants/configConstants";
import wrapperHOC from "@Utils/wrapperHOC";
import useWhitelabel from "hooks/useWhitelabel";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import SearchListItemDesktopV2 from "../SearchListItem/SearchListItemDesktopV2";
import SearchPagination from "../SearchPagination";

interface SearchListDesktopProps {
  showGridView?: boolean;
  isAgentView?: boolean;
  isMapView?: boolean;
}

const SearchListDesktop = ({
  showGridView = false,
  isAgentView = false,
  isMapView = false,
}: SearchListDesktopProps) => {
  const {
    listingRef,
    handleScroll,
    items,
    isLoading,
    meta,
    region,
    filters,
    customLocation,
    whiteLabelPartnerData,
  } = useSearchList();
  const { isWhitelabel, universityMock } = useWhitelabel();

  const isFiltersSubsectionEnabled = true;

  const areFiltersApplied = getFilterActiveStatus("Filters", filters);
  const areFiltersAppliedV2 =
    getDistanceFromCityCenterStatus(filters) ||
    getUniversityAppliedStatus(filters) ||
    getStayDurationAppliedStatus(filters);

  return (
    <div
      className={formatClassNames(styles.containerDesktop, showGridView && styles.gridView)}
      ref={listingRef}
      onScroll={handleScroll}
    >
      {items?.map((item: any, index: number) => {
        const {
          shouldShowGetHelpBanner,
          shouldShowTrustPilot,
          shouldShowBookEarlySection,
          shouldShowFilters,
          shouldShowFiltersV2,
          shouldShowRecentlyViewdSection,
        } = getSubsectionIndex({
          areFiltersApplied,
          areFiltersAppliedV2,
          resultCount: meta?.count,
          index,
          isFiltersSubsectionEnabled,
        });
        return (
          <React.Fragment key={`${item.key}_${index}`}>
            {!isWhitelabel && !isMapView && (
              <>
                {shouldShowGetHelpBanner && <GetHelpBannerV2 isDesktop />}
                {isFiltersSubsectionEnabled && shouldShowFilters && <FilterSubsection isDesktop />}
              </>
            )}

            {!(isWhitelabel && universityMock) && (
              <SearchListItemDesktopV2
                index={index}
                {...item}
                regionType={region?.region_type}
                regionId={region?.id}
                region={region}
                meta={item.meta_short}
                meta_real={item.meta}
                page={PAGE.SEARCH}
                loadedCount={items.length}
                isAgentView={isAgentView}
                customLocation={customLocation}
                whiteLabelPartnerData={whiteLabelPartnerData}
              />
            )}

            {!isWhitelabel && !isMapView && isFiltersSubsectionEnabled && shouldShowFiltersV2 && (
              <FilterSubsection2 isDesktop />
            )}

            {!isWhitelabel && !isMapView && shouldShowRecentlyViewdSection && (
              <RecentelyViewedSection
                isSearchPage
                isSearchPageRails
                gtagEventCategory={PAGE.SEARCH}
                isDesktop
              />
            )}

            {!isWhitelabel && !isMapView && shouldShowTrustPilot && !config.IS_CHINA_APP && (
              <TrustPilotReviewsBanner isSearchPage isDesktop uniCity={null} />
            )}
            {!isWhitelabel && !isMapView && shouldShowBookEarlySection && (
              <BookEarlySection isDesktop />
            )}
          </React.Fragment>
        );
      })}

      {(isLoading || universityMock) &&
        [...new Array(10)].map((_it, index) => (
          <div
            key={`loading_${index}`}
            style={{ viewTransitionName: `search-item-skeleton-${index}` }}
          >
            <SkeletonSearchListItem isDesktop={!showGridView} />
          </div>
        ))}

      {/* SSR Trustpilot: render after list if inline position (index 17) wasn't reached */}
      {!isWhitelabel &&
        !isMapView &&
        !config.IS_CHINA_APP &&
        items?.length > 0 &&
        items.length <= 17 && <TrustPilotReviewsBanner isSearchPage isDesktop uniCity={null} />}

      {/* Pagination block */}
      {items?.length > 0 && <SearchPagination />}
    </div>
  );
};

export default wrapperHOC(SearchListDesktop, {
  componentName: "SearchListDesktop-SearchPage",
  showForChina: true,
});
